<body [ngClass]="{'eab-theme': isDarkTheme | async}">
    <app-nav-menu  #menu (stateChanged)="updateHeight($event)"></app-nav-menu>
   
    <mat-progress-bar [style.opacity]="Opacity" mode="indeterminate" color="accent" role="progressbar" style="z-index: 9999;">
    </mat-progress-bar>
    <div #tata class="container-fluid" [style.height]="PageHeight" [style.overflow-y]="Overflow">
        <router-outlet></router-outlet>
    </div>
</body>